import { MailIcon, MessageSquare, MessagesSquare } from 'lucide-react';

import { ActivityNotificationEnum } from 'src/graphql/schema';

type EscrowType = 'software' | 'continuity';

type IActivityOption = {
  label: string;
  value: ActivityNotificationEnum;
};

type IActivityOptionRich = {
  label: string;
  value: ActivityNotificationEnum;
  icon: React.ElementType;
  description: string;
};

class EscrowActivityNotificationOptions {
  public readonly activityNotificationOptions: IActivityOption[];
  public readonly activityNotificationOptionsRich: IActivityOptionRich[];
  public readonly activityNotificationOptionsDictionary: Record<ActivityNotificationEnum, string>;
  public readonly activityNotificationOptionsRichDictionary: Record<
    ActivityNotificationEnum,
    { label: string; icon: React.ElementType; description: string }
  >;

  constructor(options: IActivityOption[], optionsRich: IActivityOptionRich[]) {
    this.activityNotificationOptions = options;
    this.activityNotificationOptionsRich = optionsRich;
    this.activityNotificationOptionsDictionary = options.reduce(
      (acc, { value, label }) => ({ ...acc, [value]: label }),
      {} as Record<ActivityNotificationEnum, string>,
    );
    this.activityNotificationOptionsRichDictionary = optionsRich.reduce(
      (acc, { value, label, icon, description }) => ({ ...acc, [value]: { label, icon, description } }),
      {} as Record<ActivityNotificationEnum, { label: string; icon: React.ElementType; description: string }>,
    );
  }
}

const SOFTWARE_OPTIONS: IActivityOption[] = [
  { label: 'First deposit confirmation', value: ActivityNotificationEnum.First },
  { label: 'Confirmation on every deposit', value: ActivityNotificationEnum.Each },
];

const SOFTWARE_OPTIONS_RICH: IActivityOptionRich[] = [
  {
    label: 'Activation',
    value: ActivityNotificationEnum.First,
    icon: MailIcon,
    description:
      'Members will receive an activation notification email which will include information about the initial assets.',
  },
  {
    label: 'Activation + Every deposit',
    value: ActivityNotificationEnum.Each,
    icon: MessagesSquare,
    description:
      'Members will receive an activation notification email and notifications each time a new asset is successfully deposited into escrow.',
  },
];

const CONTINUITY_OPTIONS: IActivityOption[] = [
  { label: 'Activation', value: ActivityNotificationEnum.First },
  { label: 'Activation + Every added provider', value: ActivityNotificationEnum.Each },
];

const CONTINUITY_OPTIONS_RICH: IActivityOptionRich[] = [
  {
    label: 'Activation',
    value: ActivityNotificationEnum.First,
    icon: MessageSquare,
    description:
      'Members will receive an activation notification email which will include information about the hosting environment.',
  },
  {
    label: 'Activation + Every added provider',
    value: ActivityNotificationEnum.Each,
    icon: MessagesSquare,
    description:
      'Members will receive an activation notification email and notifications each time a provider is successfully added into escrow.',
  },
];

const ESCROW_ACTIVITY_OPTIONS: Record<EscrowType, EscrowActivityNotificationOptions> = {
  software: new EscrowActivityNotificationOptions(SOFTWARE_OPTIONS, SOFTWARE_OPTIONS_RICH),
  continuity: new EscrowActivityNotificationOptions(CONTINUITY_OPTIONS, CONTINUITY_OPTIONS_RICH),
};

export const getEscrowActivityNotificationOptions = (type: EscrowType) => ESCROW_ACTIVITY_OPTIONS[type];
